import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CovanceGridColumn, dateTimeComparator, dateTimeRenderer } from '../../covance-ag-grid';
import { CommonLinkActionsMenuAgRendererComponent } from './common-link-actions-menu-ag-renderer.component';
import { CommonLinkEditorResult, CommonLinkEditorResultAction } from './common-link-editor.component';
import { CommonLinkInfo } from './common-link-info';
import { CommonLinkInfoGridRowItem } from './common-link-info-grid-row';
import { CommonLinksInfoEditor } from './common-links-editor';
import { CommonLinksInfoStorage } from './common-links-info-storage';
import { GridColumns } from '../../shared/grid-columns';
import { switchMap, map } from 'rxjs/operators';
import { comparators } from '../../core/comparators';

@Component({
    selector: 'common-links-grid',
    template: require('./common-links-grid.component.html'),
    styles: [require('./common-links-grid.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonLinksGridComponent {
    public readonly columns: CovanceGridColumn[];
    public readonly commonLinksInfoData: Observable<CommonLinkInfo[]>;

    constructor(
        private commonLinksInfoStorage: CommonLinksInfoStorage,
        private readonly commonLinksInfoEditor: CommonLinksInfoEditor,
        gridColumns: GridColumns
    ) {
        this.commonLinksInfoData = commonLinksInfoStorage.all;
        this.columns = [
            {
                headerName: 'Title',
                field: 'title',
                comparator: (a, b) => comparators.mixedStringComparator(a, b)
            },
            gridColumns.multiLineStringColumn({
                title: 'Roles',
                field: 'roles',
                stringsValueGetter: (entity: CommonLinkInfo) => entity.roles,
                tooltipGetter: (role) => [{ content: role }]
            }),
            {
                headerName: 'Url',
                field: 'url'
            },
            {
                headerName: 'Posted',
                field: 'postedDate',
                sort: 'desc',
                comparator: dateTimeComparator,
                valueGetter: (params: CommonLinkInfoGridRowItem) => {
                    if (!params.data) {
                        return null;
                    }
                    return dateTimeRenderer({ value: params.data.postedDate });
                }
            },
            {
                headerName: 'Sort Order',
                field: 'sortOrder'
            },
            gridColumns.actionsMenuColumn({ cellRendererFramework: CommonLinkActionsMenuAgRendererComponent })
        ];
    }

    public async onAddNewLink() {
        const dialogResult = await this.showCreateDialog().toPromise();

        if (dialogResult.action === CommonLinkEditorResultAction.create) {
            await this.commonLinksInfoStorage.post(dialogResult.editedEntity);
            this.commonLinksInfoStorage.forceLoadAll();
        }
    }

    private showCreateDialog(): Observable<CommonLinkEditorResult> {
        return this.commonLinksInfoEditor.openToCreate().pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult || { action: CommonLinkEditorResultAction.close })
        );
    }
}
